'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.loadAddresses = loadAddresses;
exports.addAddress = addAddress;
exports.updateAddress = updateAddress;
exports.deleteAddress = deleteAddress;

var _constants = require('redux/constants');

function loadAddresses() {
    return {
        types: [_constants.AddressConstants.ADDRESSES_LOAD, _constants.AddressConstants.ADDRESSES_LOAD_SUCCESS, _constants.AddressConstants.ADDRESSES_LOAD_FAIL],
        promise: function promise(client, IBonus) {
            return IBonus.getAddresses();
        }
    };
}
function addAddress(address) {
    return {
        types: [_constants.AddressConstants.ADDRESS_ADD, _constants.AddressConstants.ADDRESS_ADD_SUCCESS, _constants.AddressConstants.ADDRESS_ADD_FAIL],
        promise: function promise(client, IBonus) {
            return IBonus.addAddress(address);
        }
    };
}
function updateAddress(id, address, is_default) {
    return {
        types: [_constants.AddressConstants.ADDRESS_UPDATE, _constants.AddressConstants.ADDRESS_UPDATE_SUCCESS, _constants.AddressConstants.ADDRESS_UPDATE_FAIL],
        payload: {
            id: id,
            address: address,
            is_default: is_default
        },
        promise: function promise(client, IBonus) {
            return IBonus.updateAddress(id, address, is_default);
        }
    };
}
function deleteAddress(id) {
    return {
        types: [_constants.AddressConstants.ADDRESS_DELETE, _constants.AddressConstants.ADDRESS_DELETE_SUCCESS, _constants.AddressConstants.ADDRESS_DELETE_FAIL],
        payload: id,
        promise: function promise(client, IBonus) {
            return IBonus.deleteAddress(id);
        }
    };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/actions/addresses.js
// module id = 260
// module chunks = 0